const ja = {
  task: {
    center: "タスクセンター",
    callTask: "タスクを呼び出す",
    giftTask: "ギフトタスク",
    liveTask: "新規タスク",
    sevenTask: "7日間のタスク",
    callMessage: "報酬を得るためにもっと電話してください",
    giftMessage: "報酬を得るために贈り物を受け取る",
    liveMessage: "Live期間を延長して、$10の報酬を獲得します",
    sevenMessage: "毎日のタスクを完了して$50の報酬を獲得する",
    cellTitle: "通話≥{d}分(時間):",
    reward: "褒賞",
    lastWeek: "先週の報酬:",
    weekGift: "ウィークリーギフト収入:",
    RewardDescription: "報酬の説明",
    everyWeekGift: "ウィークリーギフト収入<span class='web'>(Bonus)</span>",
    endTask: 'タスクは終了しました',
    query: "OK"
  },
  message: {
    taxt1: "1. 各決済サイクルは月曜日から日曜日までです。ビデオハングアウトの継続時間が{d}分以上であるほど、報酬はより寛大になります。",
    taxt2: "2. その週の1回の通話時間の評価に基づいて、週に1レベルの報酬しか受け取ることができません≥{d}分",
    taxt3: "3. 公式の確認後、報酬は前にアカウントに発行されます決済後の次の木曜日。",
    taxt4: "4. 不正行為が見つかった場合、報酬は失格となります。",
    taxt5: "5. ご不明な点がございましたら、公式にご相談ください：<span class='web'>support@honeycamweb.com</span>。",
    hint: "注：国際時間の対象",
    rewardOne1: "1.タスク開始後7日以内",
    rewardOne2: "1) Live≥2時間、通話完了率≥{d}、少なくとも6日間。",
    rewardOne3: "2) タスク開始後7日以内に、総収入は≥{d}Bonus に達します。",
    rewardOne4: "3) 上記の条件が同時に満たされる場合、タスクの終了後にプラットフォームから<span style='color: #ff2794'>{d}</span>の報酬を受け取ることができます。",
    rewardOne5: "2.アンカーは最大で1つのアカウントに報酬を与えることができ、複数のアカウントは無効です。",
    rewardOne6: "3.不正行為が見つかった場合、報酬の資格は取り消されます。",
    rewardOne7: "4.タスクが終了した後、タスクを完了したユーザー。 <span class='web' style='color: #f99634'>Facebook \"Honeycam\"</span>ホームページをフォローし、グループを追加して<span style='color: #ff2794'>$10</span>の報酬を獲得してください。",
    rewardOne8: "5.ご不明な点がございましたら、公式にご相談ください：<span class='web'>support@honeycamweb.com</span>。",
    rewardTwo1: "ミッション期間中に{d}以上稼いだユーザーは、翌日、おすすめページや人気ページのトップに入る機会があり、露出を増やすことができます。"
  },
  gift: {
    test1: "1. 決済サイクルは月曜日から日曜日です。あなたが得る贈り物が多ければ多いほど、より寛大な報酬が得られます。",
    test2: "2. 報酬は毎週1つのレベルでのみ取得でき、レベルはその週の総収益に基づいて評価されます。",
    test3: "3. 正式な確認後、次の木曜日までに収益アカウントに報酬が発行されます。",
    test4: "4. 不正行為が見つかった場合、報酬は失格となります",
    test5: "5. ご不明な点がございましたら、公式にご相談ください：<span class='web'>support@honeycamweb.com</span>。",
    giftNum: "受け取ったギフト≥{d}",
    totalBonus: "収入≥{d}<span class='web'>Bonus</span>",
    liveCallTime: "<span class='web'>live</span>≥{d}(m)",
    callTime: "≥{d}(m)電話",
    callRate: "接通率≥{d}%"
  },
  new: {
    rewardOne: "報酬1",
    rewardTwo: "報酬2",
    start: "タスクは本日0:00に正式に開始されました",
    hint: "Live≥{d}時間、通話完了率≥{d}を1日維持します。{d}の報酬を得ることができます。",
    tastReward: "ミッション中の総収入<span class='web'>Bonus</span>",
    liveTime: "今日のLive期間",
    callRate: "今日の通話完了率",
    progress: "タスクの進行状況",
    endRate: "(ターゲット≥",
    overText1: "タスクの完了おめでとうございます",
    overText2: "公式<span class='web'>Facebook \"Honeycam\"</span>をフォローし、グループを追加して{d}の報酬を獲得してください。",
    overText3: "タスクが完了せず、{d}の報酬を獲得できないのは残念です",
    overText4: "タスクの詳細については、公式<span class='web'>Facebook \"Honeycam\"</span>をフォローしてください。",
    openfb: "Facebookを開く",
  },
  week: {
    live30: "明日Live≥{d}分",
    call5: "明日の電話は≥5分",
    rewardHint: "(以下のすべてのタスクが完了すると、<span style='color: #ff2794'><span class='web'>$20</span>の追加報酬が得られます</span>)",
    newLive: "今日のLive",
    newLiveSec: "(ターゲット≥{d})",
    newCall: "今日の通話",
    newCallRate: "今日の通話完了率",
    newBonus: "今日の収入Bonsu",
    newGift: "今日のギフトの数",
    newReward: "今日の報酬",
    days: "日",
    taskReq: "タスク要件",
    task1: "1.毎日のタスクは0:00に決済され、0：00にBonusアカウントに発行されます。",
    task2: "2.その日にタスクが完了しないと、失敗します。 失敗したタスクを再開することはできません。",
    task3: "3.7日間のタスクがすべて完了すると、{d}の特典パッケージを入手できます。 ",
    task4: "4.アンカーは最大で1つのアカウントに報酬を与えることができ、複数のアカウントは無効です。 ;",
    task5: "5.不正行為が見つかった場合、報酬の資格は取り消されます。",
    task6: "6.タスクが終了した後、タスクを完了したユーザー。 <span class='web' style='color: #f99634'>Facebook \"Honeycam\"</span>ホームページをフォローし、グループを追加して<span style='color: #ff2794' class='web'>$20</span>の報酬を獲得してください。",
    task7: "7.ご不明な点がございましたら、公式にご相談ください：<span class='web'>support@honeycamweb.com</span>。",
  }
};

export default ja;
